import React from "react";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignal } from "@fortawesome/free-solid-svg-icons";

function AssignedCandidates({
  assignedCandidates,
  assignedCandidatesLoading,
  onViewCandidateProfileClick,
}) {
  return (
    <div>
      {assignedCandidatesLoading ? (
        <div className="d-flex justify-content-center align-items-center w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <h2 className="mb-4">
            Showing {assignedCandidates?.count} Assigned Candidates
          </h2>
          <ul className="mentor-list row">
            {assignedCandidates &&
              Array.isArray(assignedCandidates) &&
              assignedCandidates.map((item) => (
                <li className="col-md-4 mb-3" key={item?.id}>
                  <div className="mentor-box bg-white rounded-lg border shadow-2 p-4">
                    <div className="img-box mr-4 mb-3 d-flex">
                      <img
                        src={
                          item?.user_details?.user_meta_info &&
                          item?.user_details?.user_meta_info?.profile_image ==
                            null
                            ? "/assets/images/building-placeholder.png"
                            : item?.user_details?.user_meta_info &&
                              item?.user_details?.user_meta_info?.profile_image
                        }
                        alt="user img"
                        className="user-img border-radius-10 mr-3"
                      />
                      <div className="info">
                        <h3 className="mb-0 text-primary font-weight-medium">
                          {item?.user_details && item.user_details?.full_name}
                        </h3>
                        <p className="text-grey-4">{item?.headline}</p>
                      </div>
                    </div>
                    <div className="content flex-grow-1">
                      <p className="text-grey-4">
                        <span>
                          <FontAwesomeIcon
                            icon={faSignal}
                            className="text-grey-4 mr-2"
                          />
                        </span>
                        Has {item?.skills && item.skills.length} skills
                      </p>

                      <div className="d-flex flex-wrap align-items-center mt-2">
                        {item?.skills &&
                          Array.isArray(item?.skills) &&
                          item.skills.map((tag) => (
                            <div
                              className={
                                " bg-light-blue rounded-lg text-nowrap text-primary py-1 px-3 mr-1 text-capitalize mb-2"
                              }
                              key={tag?.id}
                            >
                              {tag?.skill_name}
                            </div>
                          ))}
                      </div>
                      <div className="border-top pt-3 mt-3 d-flex justify-content-between align-items-center">
                        <p className="text-grey-4">Profile matches this job</p>
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            onViewCandidateProfileClick(
                              item?.user_details && item.user_details?.hash_id
                            )
                          }
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default AssignedCandidates;
